// frontend/src/pages/RetentionPolicyPage.jsx
import React, { useState } from "react";

const RULES = [
  {
    type: "Logs techniques",
    finalite: "Supervision, debug, monitoring",
    duree: "Court terme (purge automatique)",
    action: "Suppression automatique",
    onchain: "Non",
    regime: "Interne",
  },
  {
    type: "Transactions oracle",
    finalite: "Preuve d'intégrité, audit",
    duree: "Long terme / indéfini",
    action: "Archivage + ancrage on-chain",
    onchain: "✅ Hash uniquement",
    regime: "Gouvernance blockchain",
  },
  {
    type: "Certificats QUID",
    finalite: "Identité numérique, certification",
    duree: "Durée contractuelle",
    action: "Archivage sécurisé",
    onchain: "✅ Empreinte minimisée",
    regime: "RGPD + contractuel",
  },
  {
    type: "Données personnelles",
    finalite: "KYC, identification",
    duree: "Obligation légale applicable",
    action: "Anonymisation ou suppression",
    onchain: "Non (jamais brut)",
    regime: "RGPD / CNIL / EDPB",
  },
  {
    type: "Prix & valeurs marché",
    finalite: "Historique, dashboard",
    duree: "Moyen terme",
    action: "Conservation ou purge",
    onchain: "Optionnel",
    regime: "Interne",
  },
];

export default function RetentionPolicyPage() {
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "80px auto 40px", color: "#eee", fontFamily: "Arial, sans-serif", background: "rgba(10, 10, 15, 0.85)", backdropFilter: "blur(10px)", borderRadius: "12px", border: "1px solid #333", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)" }}>
      {/* EN-TÊTE */}
      <div style={{ maxWidth: "860px", margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
          <span style={{ fontSize: "1.6rem" }}>🔒</span>
          <h1 style={{ margin: 0, color: "#00FF94", fontSize: "1.8rem", letterSpacing: "2px" }}>
            Conservation & Conformité des Données
          </h1>
        </div>
        <p style={{ color: "#aaa", fontSize: "0.95rem", marginBottom: "40px", maxWidth: "680px" }}>
          Notre plateforme applique un moteur de décision automatique (RCDE) qui attribue à chaque
          enregistrement une politique de conservation, d'archivage ou de purge, selon sa nature
          et les obligations réglementaires applicables.
        </p>

        {/* PRINCIPE GÉNÉRAL */}
        <div style={{
          background: "rgba(0,255,148,0.05)",
          border: "1px solid rgba(0,255,148,0.3)",
          borderRadius: "12px",
          padding: "20px 24px",
          marginBottom: "36px",
        }}>
          <h2 style={{ color: "#00FF94", margin: "0 0 12px 0", fontSize: "1rem", letterSpacing: "1px" }}>
            PRINCIPE GÉNÉRAL
          </h2>
          <ul style={{ color: "#ccc", paddingLeft: "20px", lineHeight: "1.8", margin: 0 }}>
            <li>
              <strong style={{ color: "#fff" }}>Conservation minimale off-chain</strong> — seules
              les données nécessaires sont conservées, pour la durée strictement requise.
            </li>
            <li>
              <strong style={{ color: "#fff" }}>Preuve durable on-chain</strong> — la blockchain
              ne stocke que des empreintes cryptographiques, jamais de données personnelles brutes.
            </li>
            <li>
              <strong style={{ color: "#fff" }}>Privacy by Design</strong> — conformité intégrée
              dès la conception, conformément à l'Art. 25 RGPD, aux recommandations CNIL et EDPB.
            </li>
            <li>
              <strong style={{ color: "#fff" }}>Décision automatique par enregistrement</strong> — 
              chaque transaction est qualifiée et traitée selon son type sans intervention manuelle.
            </li>
          </ul>
        </div>

        {/* MATRICE */}
        <h2 style={{ color: "#0ff", fontSize: "1rem", letterSpacing: "1px", marginBottom: "16px" }}>
          MATRICE DE CONSERVATION PAR TYPE DE DONNÉE
        </h2>

        {/* DESKTOP TABLE */}
        <div style={{ overflowX: "auto", marginBottom: "40px" }}>
          <table style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "0.88rem",
          }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #0ff" }}>
                {["Type de donnée","Finalité","Durée","Action","On-chain","Régime"].map(h => (
                  <th key={h} style={{
                    padding: "10px 12px", textAlign: "left",
                    color: "#0ff", fontWeight: "600", whiteSpace: "nowrap",
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {RULES.map((r, i) => (
                <tr key={i} style={{
                  borderBottom: "1px solid #1a2a2a",
                  background: i % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent",
                  transition: "background 0.2s",
                }}
                  onMouseOver={e => e.currentTarget.style.background = "rgba(0,255,148,0.05)"}
                  onMouseOut={e => e.currentTarget.style.background = i % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent"}
                >
                  <td style={{ padding: "10px 12px", color: "#fff", fontWeight: "600" }}>{r.type}</td>
                  <td style={{ padding: "10px 12px", color: "#ccc" }}>{r.finalite}</td>
                  <td style={{ padding: "10px 12px", color: "#ffd369" }}>{r.duree}</td>
                  <td style={{ padding: "10px 12px", color: "#ccc" }}>{r.action}</td>
                  <td style={{ padding: "10px 12px", color: r.onchain.startsWith("✅") ? "#00FF94" : "#666" }}>{r.onchain}</td>
                  <td style={{ padding: "10px 12px", color: "#a575eb" }}>{r.regime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* BLOC VOS DROITS */}
        <div style={{
          background: "rgba(0,0,0,0.4)",
          border: "1px solid #333",
          borderRadius: "12px",
          padding: "20px 24px",
          marginBottom: "36px",
        }}>
          <h2 style={{ color: "#ffd369", margin: "0 0 12px 0", fontSize: "1rem", letterSpacing: "1px" }}>
            VOS DROITS (RGPD)
          </h2>
          <ul style={{ color: "#ccc", paddingLeft: "20px", lineHeight: "1.8", margin: 0 }}>
            <li>Droit d'accès, de rectification et d'effacement sur les données off-chain.</li>
            <li>Les preuves on-chain sont immuables par nature mais ne contiennent aucune donnée personnelle directe.</li>
            <li>Toute demande de suppression est traitée dans les délais réglementaires (30 jours).</li>
          </ul>
        </div>

        {/* CALLOUT MOTEUR */}
        <div style={{
          background: "#0a0a0a",
          borderLeft: "3px solid #0ff",
          borderRadius: "0 8px 8px 0",
          padding: "14px 18px",
          color: "#ccc",
          fontSize: "0.9rem",
          marginBottom: "40px",
        }}>
          <strong style={{ color: "#0ff" }}>Moteur RCDE (Retention & Compliance Decision Engine) : </strong>
          chaque enregistrement est automatiquement qualifié, horodaté et assigné à une politique
          de conservation sans intervention manuelle. Les décisions sont tracées et auditables.
        </div>

        {/* FOOTER */}
        <p style={{ color: "#555", fontSize: "0.8rem", textAlign: "center" }}>
          Conformité : RGPD Art. 5, 17, 25 · CNIL Blockchain 2024 · EDPB Guidelines 02/2025
        </p>
      </div>
    </div>
  );
}
